import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { SharedModule } from '../../shared/shared.module';
import { NgOtpInputModule } from  'ng-otp-input';
import { LandingComponent } from '../landing/landing.component';
import { AboutComponent } from '../../about/about.component';
import { FaqComponent } from '../../faq/faq.component';
import { TermComponent } from '../../term/term.component';
import { PrivacyPolicyComponent } from '../../privacy-policy/privacy-policy.component';
import { HelpDeskComponent } from '../../help-desk/help-desk.component';
import { LgFooterComponent } from '../../lg-footer/lg-footer.component';
import { CookiePolicyComponent } from '../../cookie-policy/cookie-policy.component';

const router: Routes = [
  { path: '', component: LoginComponent },
  { path: "login", component: LoginComponent },
  { path: "about", component: AboutComponent },
  { path: "faq", component: FaqComponent },
  { path: "term", component: TermComponent },
  { path: "helpDesk", component: HelpDeskComponent },
  { path: "privacyPolicy", component: PrivacyPolicyComponent },
  { path: "cookiePolicy", component: CookiePolicyComponent },
];

@NgModule({
  imports: [CommonModule,SharedModule, RouterModule.forChild(router), FormsModule, ReactiveFormsModule, HttpClientModule,NgOtpInputModule],
  declarations: [LoginComponent, LandingComponent, AboutComponent, FaqComponent,TermComponent,HelpDeskComponent,PrivacyPolicyComponent,LgFooterComponent,CookiePolicyComponent]
})
export class LoginModule { }
